/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Contact_Representative_LabelInputs */

const es_privacy_policy_contact_representative_label = /** @type {(inputs: Privacy_Policy_Contact_Representative_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Representante de Datos`)
};

const en_privacy_policy_contact_representative_label = /** @type {(inputs: Privacy_Policy_Contact_Representative_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Representative`)
};

/**
* | output |
* | --- |
* | "Data Representative" |
*
* @param {Privacy_Policy_Contact_Representative_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_contact_representative_label = /** @type {((inputs?: Privacy_Policy_Contact_Representative_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Contact_Representative_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_contact_representative_label(inputs)
	return en_privacy_policy_contact_representative_label(inputs)
});
export { privacy_policy_contact_representative_label as "privacy_policy.contact.representative_label" }